import Button from '@mui/material/Button';
import TicketIcon from '../../resources/images/icons/ticket.png';

const MyButton = (props) => {
	return (
		<Button
			href={props.link}
			target='_blank'
			variant='contained'
			size='small'
			style={{
				background: props.bck,
				color: props.color,
			}}
		>
			<img src={TicketIcon} className='iconImage' alt='icon_button' />
			{props.text}
		</Button>
	);
};

export default MyButton;
